export const TABS = {
  GENERAL_INFORMATION: "GENERAL_INFORMATION",
  FEEDBACK_FORM: "FEEDBACK_FORM",
  QUESTIONNAIRE: "QUESTIONNAIRE",
  ASSETS: "ASSETS",
};

export const TABS_BUTTONS = [
  {
    title: "General Information",
    key: TABS.GENERAL_INFORMATION,
  },
  {
    title: "Collected Assets",
    key: TABS.ASSETS,
    allowCategories: ["Asset Collection"],
    showCategory: false,
  },
  {
    title: "Questionnaire",
    key: TABS.QUESTIONNAIRE,
    allowCategories: ["Intervention", "Follow Up", "Safety", "Survey"],
    showCategory: true,
  },
  {
    title: "Feedback Form",
    key: TABS.FEEDBACK_FORM,
    allowCategories: ["Intervention Call"],
    showCategory: false,
  },
];

export const SORTED_GENERAL_KEYS = [
  "priority",
  "routineId",
  "assignedBy",
  "assignedTo",
  "assignedToName",
  "comments",
  "plannedVisitDatetime",
  "updatedAt",
  "updatedBy",
];
export const SORTED_CUSTOMER_KEYS = ["name", "id", "status", "phone", "location"];

export const getStatus = (status, isPaid) => {
  switch (status) {
    case "Okay":
      return "Scanned";
    case "Missing":
      return isPaid ? "Paid" : status;
    default:
      return status;
  }
};

export const STATUS_COLOR_MAP = {
  Scanned: {
    color: "#17C347",
    backgroundColor: "transparent",
  },
  Damaged: {
    color: "#DB6607",
    backgroundColor: "transparent",
  },
  Paid: {
    color: "#0085FF",
    backgroundColor: "transparent",
  },
  Missing: {
    color: "#FF0000",
    backgroundColor: "transparent",
  },
};
